import React, { forwardRef } from "react"
import { StyleSheet, View } from "react-native"
import { PaymentElement } from "@stripe/react-stripe-js/checkout"
import { theme } from "@common/theme/theme"
import TextM from "@common/components/text/TextM"
import FilledButtonM from "@common/components/button/FilledButtonM"
import { FontAwesome5 } from "@expo/vector-icons"
import { HOSTED_FALLBACK_LABEL } from "../newSubscriptionUtils"

export const NewSubscriptionPaymentCard = forwardRef(
    (
        {
            setError,
            cardCompleteRef,
            onReady,
            onLoadError,
            elementFailed,
            hostedFallback,
        },
        ref
    ) => {
        return (
            <View ref={ref} style={styles.card}>
                <View style={styles.headerRow}>
                    <TextM
                        fontWeight="bold"
                        fontSize={18}
                        color={theme.colors.black}
                    >
                        Paiement
                    </TextM>
                    <View style={styles.secureBadge}>
                        <FontAwesome5
                            name="lock"
                            size={10}
                            color={theme.colors.grey}
                        />
                        <TextM fontSize={11} color={theme.colors.grey}>
                            Paiement sécurisé via Stripe
                        </TextM>
                    </View>
                </View>
                {elementFailed && hostedFallback && (
                    <View style={styles.fallback}>
                        <TextM wrap color={theme.colors.black}>
                            Le formulaire de paiement ne s'affiche pas sur ce
                            navigateur. Vous pouvez régler sur la page sécurisée
                            de Stripe, notre prestataire de paiement.
                        </TextM>
                        <FilledButtonM
                            label={HOSTED_FALLBACK_LABEL}
                            icon="lock"
                            loading={hostedFallback.isOpening}
                            onPress={() =>
                                hostedFallback.openHostedCheckout(
                                    "element_failed"
                                )
                            }
                            style={{ width: null, paddingHorizontal: 12 }}
                            wrapText
                        />
                    </View>
                )}
                <PaymentElement
                    options={{ layout: "tabs" }}
                    onReady={onReady}
                    onLoadError={onLoadError}
                    onChange={(event) => {
                        setError(event?.error?.message ?? null)
                        if (cardCompleteRef) {
                            cardCompleteRef.current = event?.complete ?? false
                        }
                    }}
                />
            </View>
        )
    }
)

const styles = StyleSheet.create({
    card: {
        padding: 20,
        borderRadius: 20,
        gap: 15,
        borderWidth: 1,
        borderColor: theme.colors.lightMore,
    },
    headerRow: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
    },
    secureBadge: {
        flexDirection: "row",
        alignItems: "center",
        gap: 4,
    },
    fallback: {
        gap: 12,
        padding: 15,
        borderRadius: 12,
        backgroundColor: theme.colors.lightMore,
    },
})
